<!-- BOARDS -->
<div id="boards" class="fuse-white" fxLayout="column" fxLayoutAlign="start center" fxFlex fusePerfectScrollbar>

  <div class="header pt-24 pt-md-68" fxLayout="row" fxLayoutAlign="center center" fxFlex="0 0 auto"
       [@animate]="{value:'*',params:{delay:'100ms'}}">
      

      <div class="logo" [@animate]="{value:'*',params:{scale:'0.2'}}">
          <img width="250" src="assets/images/logos/tr2.png">
      </div>
  </div>

  <!-- BOARD LIST -->
  <section *ngFor="let option of boards" fxFlex="0 0 auto" fxLayout="column wrap" fxLayoutAlign="center start">
    
  <div class="board-list" fxFlex="0 0 auto" fxLayout="row wrap" fxLayoutAlign="center center"
      [@animateStagger]="{value:'50'}" >
      <!--Board title-->
      <div class="board-list-item board-title {{option.id}}"
          fxLayout="column" fxLayoutAlign="center center"
          [@animate]="{value:'*',params:{y:'100%'}}">
        <mat-icon class="s-36">{{option.icon}}</mat-icon>
        <div class="board-name">{{option.name}}</div>
    </div>
      <!-- BOARD -->
      <div class="board-list-item board-item accent {{board.id}}" *ngFor="let board of option.boards"
           [routerLink]="[board.path]" routerLinkActive="router-link-active" 
           fxLayout="column" fxLayoutAlign="center center"
           [@animate]="{value:'*',params:{y:'100%'}}">
          <mat-icon class="s-28">{{board.icon}}</mat-icon>
          <div class="board-name">{{board.name}}</div>
      </div>
      <!-- / BOARD -->

  </div>
  <!-- / BOARD LIST -->
  </section>
</div>
<!-- / BOARDS -->
